import { Network } from '@capacitor/network';
import { ref, onMounted, onUnmounted } from 'vue';

// Create a reactive reference to track network status
export const isOnline = ref(true);

// Create a composable function to use network status
export function useNetworkStatus() {
  // Function to update the network status
  const updateNetworkStatus = async () => {
    try {
      const status = await Network.getStatus();
      isOnline.value = status.connected;
    } catch (error) {
      console.error('Error getting network status:', error);
      // Fallback to browser API if Capacitor Network plugin fails
      isOnline.value = navigator.onLine;
    }
  };

  // Set up event listeners when component is mounted
  onMounted(() => {
    // Initialize network status
    updateNetworkStatus();

    // Listen for network status changes
    Network.addListener('networkStatusChange', (status) => {
      isOnline.value = status.connected;
    });
  });

  // Clean up event listeners when component is unmounted
  onUnmounted(() => {
    Network.removeAllListeners();
  });

  return {
    isOnline,
    updateNetworkStatus
  };
}